import { render, staticRenderFns } from "./betreff-einstellungen.vue?vue&type=template&id=1f55cd84&scoped=true&"
import script from "./betreff-einstellungen.vue?vue&type=script&lang=js&"
export * from "./betreff-einstellungen.vue?vue&type=script&lang=js&"
import style0 from "./betreff-einstellungen.vue?vue&type=style&index=0&id=1f55cd84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f55cd84",
  null
  
)

export default component.exports